(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    (() => {
    const selector = '[data-sticky-details-scroll-handoff]';
    const observers = new WeakMap();

    const initialize = (root = document) => {
      root.querySelectorAll(selector).forEach((details) => {
        if (!(details instanceof HTMLElement) || observers.has(details)) return;

        const updateHeight = () => {
          details.style.setProperty('--product-details-height', `${details.getBoundingClientRect().height}px`);
        };

        const observer = new ResizeObserver(updateHeight);
        observers.set(details, observer);
        observer.observe(details);
        updateHeight();
      });
    };

    const disconnect = (root) => {
      root.querySelectorAll(selector).forEach((details) => observers.get(details)?.disconnect());
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof HTMLElement) initialize(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target instanceof HTMLElement) disconnect(event.target);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["footer-policy-list"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-cookie-preferences-trigger]');

    if (!trigger) return;

    event.preventDefault();
    window.privacyBanner?.showPreferences?.();
  });
  } catch(e) { console.error(e); }
})();

})();
